<script setup lang="ts">
definePageMeta({
  title: 'Transfer',
  layout: 'default',
})
</script>

<template>
  <Transfer />
</template>
